import { AddSeriesModal } from './AddSeriesModal';

export default AddSeriesModal;
